<template>
    <div>
        <Index></Index>
    </div>
</template>

<script>
import Index from "@stations/.components/index.vue"
export default {
    name: "StationsMain",
    data() {
        return {
            is_initialized: false,
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
        Index
    }
}
</script>
